'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactackleTooltipIcon = require('reactackle-tooltip-icon');

var _reactackleCore = require('reactackle-core');

var _ToggleStyled = require('./styles/ToggleStyled');

var _ToggleBarBoxStyled = require('./styles/ToggleBarBoxStyled');

var _ToggleBarStyled = require('./styles/ToggleBarStyled');

var _ToggleInputStyled = require('./styles/ToggleInputStyled');

var _ToggleLabelStyled = require('./styles/ToggleLabelStyled');

var _ToggleLabelTextBoxStyled = require('./styles/ToggleLabelTextBoxStyled');

var _ToggleLabelTextStyled = require('./styles/ToggleLabelTextStyled');

var _ToggleTooltipBoxStyled = require('./styles/ToggleTooltipBoxStyled');

var _theme = require('./styles/theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

(0, _reactackleCore.registerDefaultComponentTheme)('toggleButton', _theme2.default);

var propTypes = {
  /**
   * Determines whether ToggleButton is checked
   */
  checked: _propTypes2.default.bool,
  /**
   * Determines whether ToggleButton is checked by default
   */
  defaultChecked: _propTypes2.default.bool,
  /**
   * Determines whether ToggleButton is disabled
   */
  disabled: _propTypes2.default.bool,
  /**
   * Determines ToggleButton label
   */
  label: _propTypes2.default.string,
  /**
   * Determines ToggleButton tooltip
   */
  tooltip: _propTypes2.default.string,
  /**
   * Determines ToggleButton label position
   */
  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
  /**
   * Specify function to call on ToggleButton state change
   */
  onChange: _propTypes2.default.func
};
var defaultProps = {
  checked: void 0,
  defaultChecked: false,
  disabled: false,
  label: '',
  tooltip: '',
  labelPosition: 'left',
  onChange: _reactackleCore.noop
};

var nextId = 0;

var ToggleButton = function (_Component) {
  _inherits(ToggleButton, _Component);

  function ToggleButton(props) {
    _classCallCheck(this, ToggleButton);

    var _this = _possibleConstructorReturn(this, (ToggleButton.__proto__ || Object.getPrototypeOf(ToggleButton)).call(this, props));

    _this._inputId = 'toggle-' + nextId++;

    _this.state = {
      checked: (0, _reactackleCore.isUndef)(props.checked) ? props.defaultChecked : props.checked,
      hovered: false,
      focused: false
    };

    _this._handleChange = _this._handleChange.bind(_this);
    _this._handleMouseEnter = _this._handleMouseEnter.bind(_this);
    _this._handleMouseLeave = _this._handleMouseLeave.bind(_this);
    _this._handleFocus = _this._handleFocus.bind(_this);
    _this._handleBlur = _this._handleBlur.bind(_this);
    return _this;
  }

  _createClass(ToggleButton, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var isDefaultValueChanged = nextProps.defaultChecked !== this.props.defaultChecked;

      if (isDefaultValueChanged) {
        this.setState({ checked: nextProps.defaultChecked });
      }
    }
  }, {
    key: '_handleChange',
    value: function _handleChange(event) {
      var checked = event.target.checked;
      this.props.onChange({
        value: checked
      });

      if ((0, _reactackleCore.isUndef)(this.props.checked)) this.setState({ checked: checked });
    }
  }, {
    key: '_handleMouseEnter',
    value: function _handleMouseEnter() {
      this.setState({
        hovered: true
      });
    }
  }, {
    key: '_handleMouseLeave',
    value: function _handleMouseLeave() {
      this.setState({
        hovered: false
      });
    }
  }, {
    key: '_handleFocus',
    value: function _handleFocus() {
      this.setState({ focused: true });
    }
  }, {
    key: '_handleBlur',
    value: function _handleBlur() {
      this.setState({ focused: false });
    }
  }, {
    key: '_renderTooltip',
    value: function _renderTooltip() {
      if (!this.props.tooltip) return null;

      return _react2.default.createElement(
        _ToggleTooltipBoxStyled.ToggleTooltipBoxStyled,
        null,
        _react2.default.createElement(_reactackleTooltipIcon.TooltipIcon, { text: this.props.tooltip })
      );
    }
  }, {
    key: '_renderLabel',
    value: function _renderLabel() {
      if (!this.props.label) return null;

      var tooltip = this._renderTooltip(),
          checked = (0, _reactackleCore.isUndef)(this.props.checked) ? this.state.checked : this.props.checked;

      return _react2.default.createElement(
        _ToggleLabelTextBoxStyled.ToggleLabelTextBoxStyled,
        {
          disabled: this.props.disabled,
          checked: checked,
          hasTooltip: this.props.tooltip,
          labelPosition: this.props.labelPosition
        },
        _react2.default.createElement(
          _ToggleLabelTextStyled.ToggleLabelTextStyled,
          { hasTooltip: this.props.tooltip },
          this.props.label
        ),
        tooltip
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var checked = (0, _reactackleCore.isUndef)(this.props.checked) ? this.state.checked : this.props.checked;

      var label = this._renderLabel();

      return _react2.default.createElement(
        _ToggleStyled.ToggleStyled,
        {
          onMouseEnter: this._handleMouseEnter,
          onMouseLeave: this._handleMouseLeave,
          disabled: this.props.disabled
        },
        _react2.default.createElement(
          _ToggleLabelStyled.ToggleLabelStyled,
          {
            htmlFor: this._inputId,
            disabled: this.props.disabled
          },
          _react2.default.createElement(
            _ToggleBarBoxStyled.ToggleBarBoxStyled,
            {
              labelPosition: this.props.labelPosition,
              disabled: this.props.disabled
            },
            _react2.default.createElement(_ToggleBarStyled.ToggleBarStyled, {
              htmlFor: this._inputId,
              checked: checked,
              disabled: this.props.disabled,
              hover: this.state.hovered,
              focus: this.state.focused
            }),
            _react2.default.createElement(_ToggleInputStyled.ToggleInputStyled, {
              id: this._inputId,
              type: 'checkbox',
              disabled: this.props.disabled,
              checked: checked,
              onChange: this._handleChange,
              tabIndex: 0,
              onFocus: this._handleFocus,
              onBlur: this._handleBlur
            })
          ),
          label
        )
      );
    }
  }]);

  return ToggleButton;
}(_react.Component);

exports.default = ToggleButton;


ToggleButton.propTypes = propTypes;
ToggleButton.defaultProps = defaultProps;
ToggleButton.displayName = 'ToggleButton';


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-toggle-button/dist/ToggleButton.js
// module id = 863
// module chunks = 0